$(document).ready(function() {
	const carouselProgramme = $('.carousel-programme').owlCarousel({
		items: 1,
		dots: false,
		loop: true,
		autoplay: true
	})

	const carouselProgrammeModal = $('.carousel-programme-modal').owlCarousel({
		items: 1,
		dots: false,
		loop: true,
		autoplay: true
	})

	$('.owlNext').on('click', function() {
		carouselProgramme.trigger('next.owl.carousel')
		carouselProgrammeModal.trigger('next.owl.carousel')
	})

	$('.owlPrev').on('click', function() {
		carouselProgramme.trigger('prev.owl.carousel')
		carouselProgrammeModal.trigger('prev.owl.carousel')
	})

	const queryParams = new URLSearchParams(window.location.search)

	$.ajax({
		url: '/api/programme/programmesSimilaires',
		type: 'GET',
		dataType: 'json',
		data: {
			programmeId: $('#programmeId').val()
		},
		success: function(data) {
			$('#programmeSimilaires').html(data.html)
		},
		error: function(err) {
			console.log(err)
		}
	})

	$.ajax({
		url: '/api/programme/lots',
		type: 'GET',
		dataType: 'json',
		data: {
			programmeId: $('#programmeId').val(),
			pour: queryParams.get('pour')
		},
		success: function(data) {
			$('#wrapperLotsProgramme').html(data.html)
			if ($('.isPsla').val() == '1') {
				$('.tvaValue').text('(TVA 5,5%)')
			} else {
				$('.toggleTva').trigger('change')
			}
		},
		error: function(err) {
			console.log(err)
		}
	})

	$(document).on('change', '.toggleTva', function() {
		const isChecked = $(this).is(':checked')

		const allTdPrices = $('.tdPriceWrapper')
		const isLLI = $('.isLLI').val()
		const isTvaReduite = $('.isTvaReduite').val()
		const tvaSpan = $('.tvaText')

		let tvaText
		if (isLLI === '1' && isTvaReduite !== '1') {
			tvaText = '(TVA 10%)'
		} else if (isTvaReduite === '1') {
			tvaText = '(TVA 5,5%)'
		} else {
			tvaText = '(TVA 20%)'
		}

		// Afficher le label dans le span du toggle
		tvaSpan.text(isChecked ? tvaSpan.data('tva-label') : 'TVA 20%')

		allTdPrices.each(function() {
			const price = $(this).find('input[type="hidden"]').val().split(' / ')
			const spanValue = $(this).find('.priceValue')
			const tvaValue = $(this).find('.tvaValue')
			if (isChecked) {
				spanValue.text(price[0])
				tvaValue.text(tvaText)
			} else {
				spanValue.text(price[1])
				tvaValue.text('(TVA 20%)')
			}
		})

		const priceValueTableHeaderWrapper = $('.priceValueTableHeaderWrapper')

		priceValueTableHeaderWrapper.each(function() {
			const price = $(this).find('input[type="hidden"]').val().split(' / ')
			const spanValue = $(this).find('.priceValueTableHeader')
			if (isChecked) {
				spanValue.text(price[0])
			} else {
				spanValue.text(price[1])
			}
		})
	})
})
